import { render, staticRenderFns } from "./CharityEvents.vue?vue&type=template&id=4be1cfb9"
import script from "./CharityEvents.vue?vue&type=script&lang=js"
export * from "./CharityEvents.vue?vue&type=script&lang=js"
import style0 from "./CharityEvents.vue?vue&type=style&index=0&id=4be1cfb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports